export const MyPage = {
  Header: {
    Title: 'マイページ',
  },
  FamilyInfo: {
    Title: '家族情報',
    AddFamily: '家族追加',
  },
  BasicInfo: {
    Title: '基本情報',
    TelNo: '電話番号',
    MailAddress: 'メールアドレス',
    DeliveryAddress: '配送先住所',
    Password: 'パスワード',
    PaymentMethod: 'クレジットカード',
    ReserveHistory: '予約履歴',
    FirstNamePlaceHolder: '名',
    LastNamePlaceHolder: '姓',
  },
  SettingInfo: {
    Title: '設定',
    NoticeSetting: '通知設定',
    FamilyPharmacySetting: 'かかりつけ薬局',
    OtherAppLinkage: '他アプリとの連携',
    CorporationLinkCancellation: '法人向け健康サポート利用解除',
    TalkingSetting: '通話設定',
    AuthSetting: '認証設定',
    QRCodeSetting: 'QRコード設定',
    PersonalInformationDisclosure: '個人情報（第三者提供）',
    WemexAppLinkage: 'e薬Linkでのデータ引継ぎ',
    JahisExport: '処方薬データの出力',
    MynaPortal: 'マイナポータル連携',
  },
  OtherInfo: {
    Title: 'その他',
    Help: 'ヘルプ',
    Inquiry: 'お問い合わせ',
    TermsOfUse: '利用規約',
    PrivacyPolicy: 'プライバシーポリシー',
    Licence: '著作権表示',
    Version: 'バージョン',
    HCAFrontVersion: 'HCAフロントエンドバージョン',
    HCABackEndVersion: 'HCAバックエンドバージョン',
    CommonBackEndVersion: '共通バックエンドバージョン',
  },
  OthersInquiry: {
    Title: 'お問い合わせ',
    Content1: '薬局に関する内容は、直接薬局へお問い合わせください。',
    Content2:
      'お問い合わせの対応は受付時間内とさせて頂いております。お問い合わせの内容によっては、返信にお時間がかかる場合がございます。あらかじめご了承下さい。',
    ContactKind: 'お問い合わせ種別',
    ContactContent: 'お問い合わせ内容',
    ContactPlaceHolder: '1000文字以内でご入力ください。',
    Kind: {
      NotSelect: '未選択',
      Application: 'アプリに対するご意見・ご要望',
      Incident: 'アプリの不具合（障害）のお問い合わせ',
      Personal: '個人情報の削除、開示に関するお問い合わせ',
    },
    ErrorInput: {
      MailInputError: 'メールアドレスのフォーマットが正しくありません。',
    },
  },
  CompleteInquiry: {
    Title: 'お問い合わせ完了',
    Content: 'お問い合わせが完了しました。',
  },
  Login: {
    ConfirmMessage: 'ログインすると、ログイン前に作成した情報は残りません。',
    CantLoginMessage: '未完了の調剤予約があるため、ログインできません。',
    Accept: 'ログインする',
  },
  Logout: {
    Message: 'ログアウトしますか？',
    Accept: 'ログアウトする',
  },
  BeforeDelete: {
    Header: '退会前確認事項',
    Warning: '未完了の調剤予約があるため、退会できません。',
    Message: '退会すると、タヨリスアプリのデータが全て削除されます。',
  },
  ConfirmDelete: {
    Header: '退会最終確認',
    Message: '本当に退会しますか？',
  },
  Pregnancy: {
    Period: '妊娠中#カ月',
  },
  DeleteComplete: {
    Header: '退会完了',
    Message: '退会が完了しました。',
  },
  Button: {
    Login: 'ログイン',
    CreateAccount: 'アカウント作成',
    Logout: 'ログアウト',
    Agree: '同意する',
    Withdrawal: '退会',
    Delete: '退会する',
    ToLogin: 'ログイン画面',
    Submit: '送信',
    Home: 'ホーム画面',
    OK: 'OK',
  },
  SelfInfo: '本人情報',
  Update: {
    Text: '情報を更新しました。',
  },
};

export const EditUser = {
  Header: {
    UserSelf: '本人情報（編集）',
    Family: '家族情報（編集）',
  },
  SubTitle: {
    UserSelf: '本人情報',
    Family: '家族情報',
    MedicalInterview: '問診票',
    Setting: {
      MajorItemName: '設定',
      ItemName: '個人情報提供設定',
    },
  },
  Content: {
    IdConfirmation: '本人確認',
    Name: 'お名前（漢字）',
    ForeignNameAttention: '※外国籍の方は、ローマ字で入力して下さい。',
    FirstName: '名',
    LastName: '姓',
    NameKana: 'お名前（カタカナ）',
    FirstNameKana: '名（カタカナ）',
    LastNameKana: '姓（カタカナ）',
    Weight: '体重',
    WeightUnit: 'Kg',
    Nothing: 'なし',
  },
  Button: {
    Update: '更新する',
    Cancel: 'キャンセル',
  },
  Message: {
    Identification: {
      DialogText: '本人情報を変更すると本人確認が解除されます。',
      DialogSubText:
        '本人情報を変更すると本人確認が解除され、お薬受け取り時に自動連携ができなくなります。',
    },
    Approving: {
      DialogText:
        '本人確認中です。本人情報を変更すると本人確認依頼がキャンセルされます。',
      DialogSubText:
        '本人情報を変更すると本人確認依頼がキャンセルされ、再度本人確認依頼が必要となります。',
    },
  },
};

export const EditEmailAddress = {
  Header: {
    Title: '基本情報（メールアドレス）',
  },
  Form: {
    Label: 'メールアドレス',
  },
};

export const UpdatedDialog = {
  Message: '情報を更新しました。',
  Accept: 'OK',
};

export const LicencePage = {
  Header: {
    Title: '著作権表示',
  },
};
